import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Card,
  Divider,
  Empty,
  Form,
  Icon,
  List,
  message,
  Modal,
  Select,
  Skeleton,
  Spin,
  Table,
  Tooltip
} from "antd";
import { Link } from "react-router-dom";

import { getCompatibleSpares, getSubAssemblySpares } from "../../appRedux/actions/SparePart";
import { fetchRelationshipSearchData, getSpareInventoryFilters } from "../../appRedux/actions";

class SpareSubAssembly extends Component {
  state = {
    selectedAsset: null,
    selectedAssetModel: null,
    selectedAssetSubAssembly: null,
    showCompatibleSpare: false,
    selectedSpare: null,
    compatibleSpares: {},
  };
  componentDidMount = () => {
    this.props.getSpareInventoryFilters();
    this.fetchData();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.compatibleSpares && JSON.stringify(nextProps.compatibleSpares) !== JSON.stringify(this.props.compatibleSpares)) {
      const compatibleSpares = {};
      compatibleSpares[`${this.state.selectedSpare}`] = nextProps.compatibleSpares;
      this.setState({
        compatibleSpares: { ...this.state.compatibleSpares, ...compatibleSpares }
      })
    }
  }

  fetchData = (modelId = null) => {
    if (this.props.match.params.id)
      this.props.getSubAssemblySpares(this.props.match.params.id);
    else if (modelId) {
      this.props.getSubAssemblySpares(modelId);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.form.validateFields((err, values) => {
      if (err) {
      } else {
        const {
          selectedAsset, selectedAssetModel
        } = this.state;
        // console.log(selectedAsset, selectedAssetModel)
        if (selectedAsset) {
          if (selectedAssetModel && selectedAssetModel.subAssembly && selectedAssetModel.subAssembly.length)
            this.fetchData(selectedAssetModel._id || '');
          else {
            if (selectedAssetModel)
              message.error(`Asset ${selectedAsset.assetCode} with model : ${selectedAssetModel.name} not associated with any sub-assembly!`);
            else
              message.error(`Asset : ${selectedAsset.assetCode} not associated with any Model!`);
          }
        } else if (selectedAssetModel && !selectedAssetModel._id) {
          this.fetchData(selectedAssetModel || '');
        }
      }
    });
  };

  handleSelect = (type, value) => {
    switch (type) {
      case 'asset':
        const selectedAsset = this.props.assetData.filter(asset => asset._id === value);
        this.setState({
          selectedAsset: selectedAsset[0] || null,
          selectedAssetModel: selectedAsset[0].assetModel || null,
          // selectedAssetSubAssembly: selectedAsset[0].assetModel.subAssembly || null,
        });
        break;
      case 'assetModel':
        // const selectedAssetModel = this.props.assetData.filter(asset => asset._id === value);
        this.setState({
          // selectedAsset: selectedAsset[0] || null,
          selectedAssetModel: value || null,
          // selectedAssetSubAssembly: selectedAsset[0].assetModel.subAssembly || null,
        });
        break;
      default:
    }
  };

  fetchSearch = (value, type = 'Asset') => {
    if (value && value.length >= 3) {
      if (type === 'Asset')
        this.props.fetchRelationshipSearchData(value, 'Asset', 'assetCode');
      else if (type === 'Model')
        this.props.fetchRelationshipSearchData(value, 'AssetModel', 'name');
    }
  };

  fetchSpareCompatibility = (spareId) => {
    if (spareId) {
      const fetchedData = this.state.compatibleSpares;
      if (!fetchedData.hasOwnProperty(spareId)) {
        this.props.getCompatibleSpares(spareId);
      }
      this.setState({ selectedSpare: spareId, showCompatibleSpare: true, })
    }
  };

  handleCancel = () => {
    this.setState({
      showCompatibleSpare: !this.state.showCompatibleSpare,
    })
  };

  expandedRowRender = (item) => {
    const cols = [
      {
        title: "Spare Type",
        dataIndex: "type",
        key: "type",
        render: (type) => type && type.name,
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        render: (name, record) => (
          <span style={{ verticalAlign: 'center' }}>
            <Link target={'_blank'} to={`/spare-part/edit/${record._id}`}>{name}</Link>
            &nbsp;  <Tooltip title="View compatible spares"><Icon type="api"
              style={{ cursor: 'pointer' }}
              onClick={() => this.fetchSpareCompatibility(record._id)} /></Tooltip>
          </span>
        )
      },
      {
        title: "Part No",
        dataIndex: "partCode",
        key: "partCode",
      },
      {
        title: "Code",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "Unit",
        dataIndex: "unitOfMeasurement",
        key: "unitOfMeasurement",
        render: (unitOfMeasurement) => unitOfMeasurement && unitOfMeasurement.name,
      },
      {
        title: "Is Active",
        dataIndex: "isActive",
        key: "isActive",
        render: (isActive) => isActive ? 'Yes' : 'No',
      },
    ];
    return <Table columns={cols}
      dataSource={item.data}
      pagination={false}
      rowKey={(record) =>
        record._id
      }
    />;
  };

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const { loading, assetData, subAssemblySpares } = this.props;
    let spareTable = <Skeleton active />;
    if (subAssemblySpares) {
      const cols = [
        {
          title: "Sub Assembly",
          dataIndex: "subAssembly",
          key: "subAssembly",
          // render: (type) => type && type.name,
        },
      ];
      const flattedSpares = [].concat(...this.props.subAssemblySpares);
      let uniqueData = flattedSpares.reduce((acc, obj) => {
        if (!acc.find(o => o['_id'] === obj['_id'])) {
          acc.push(obj);
        }
        return acc;
      }, []);
      const expandedData = [];
      uniqueData.forEach(doc => {
        if (doc.subAssembly && doc.subAssembly.length)
          doc.subAssembly.forEach(sa => {
            expandedData.push({ ...doc, ...{ subAssembly: sa } });
          });
        else expandedData.push({ ...doc, ...{ subAssembly: { name: 'N/A' } } });
      });
      let groupedData = (expandedData || []).reduce((acc, obj) => {
        (acc[obj.subAssembly.name] = acc[obj.subAssembly.name] || []).push(obj);
        return acc;
      }, {});

      let processedSpares = Object.keys(groupedData).map((key, index) => {
        return {
          key: index,
          subAssembly: key,
          data: groupedData[key]
        };
      });
      if (!processedSpares || processedSpares.length < 1) {
        processedSpares = [];
      }

      spareTable =
        (processedSpares && processedSpares.length) ? (
          <Table
            dataSource={processedSpares}
            // pagination={false}
            pagination={{ pageSize: 10 }}
            columns={cols}
            loading={this.props.loading}
            expandedRowRender={this.expandedRowRender}
          // rowKey={(record) =>
          //   record.name +
          //   record.code +
          //   record.partCode +
          //   record.type._id
          // }
          />
        ) : null;
    } else spareTable = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <Spin spinning={loading}>
          <Card className={`gx-card-metrics`} title={`Asset Spare Report`}>
            {!this.props.match.params.id ?
              (<Form
                onSubmit={this.handleSubmit}
                layout="inline"
                {...formItemLayout}
              >
                <Form.Item key={'asset'} label={'Asset'} style={{ width: '40%' }}>
                  {getFieldDecorator(`asset`, {
                    // rules: [{required: true, message: `Asset is required!`}],
                    initialValue: null,
                  })(<Select
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    onSearch={(val) => this.fetchSearch(val, 'Asset')}
                    onChange={value => this.handleSelect('asset', value)}
                    placeholder={`Please Enter Asset`}
                  >
                    {assetData.map(item =>
                      <Select.Option key={item._id}
                        value={item._id}>{item.assetCode} ({item.assetTypeSort || '-'})</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
                OR
                <Form.Item key={'assetModel'} label={'Asset Model'} style={{ width: '40%' }}>
                  {getFieldDecorator(`assetModel`, {
                    // rules: [{required: true, message: `Asset Model is required!`}],
                    initialValue: null,
                  })(<Select
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    onSearch={(val) => this.fetchSearch(val, 'Model')}
                    onChange={value => this.handleSelect('assetModel', value)}
                    placeholder={`Please Enter Asset Model`}
                  >
                    {assetData.map(item =>
                      <Select.Option key={item._id}
                        value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>

                <Form.Item key={`submit`} {...tailFormItemLayout}>
                  <Button type="primary" htmlType="submit" loading={loading} style={{ marginTop: '40px' }}>
                    Get Spares
                  </Button>
                </Form.Item>
              </Form>) : null}
          </Card>
          <Divider>Asset Spares</Divider>
          {spareTable}
        </Spin>

        <Modal
          title="Compatible Spares"
          visible={this.state.showCompatibleSpare}
          onCancel={this.handleCancel}
          footer={null}
        >
          <List
            bordered
            size="small"
            itemLayout="horizontal"
            dataSource={this.state.compatibleSpares[this.state.selectedSpare] || []}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta
                  title={(<Link target={'_blank'} to={`/spare-part/edit/${item._id}`} style={{ color: '#038FDE' }}>{item.name}</Link>)}
                  description={`of type ${item.type && item.type.name}`}
                />
              </List.Item>
            )}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, commonData, sparePart }) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    assetData: commonData.relationshipSearch,
    compatibleSpares: sparePart.compatibleSpares,
    subAssemblySpares: sparePart.subAssemblySpares
  };
};

function mapDispatchToProps(dispatch) {
  return {
    fetchRelationshipSearchData,
    getSpareInventoryFilters,
    getCompatibleSpares,
    getSubAssemblySpares
  };
}

const SpareSubAssemblyReport = Form.create({ name: 'asset-sub-assembly' })(SpareSubAssembly);
export default connect(mapStateToProps, mapDispatchToProps())(SpareSubAssemblyReport);
